<template>
	<div class="register-container">
		<h1>Opret klasseprofil</h1>
		<div class="form-content">
			<div v-if="loading">
				<h1>Henter info..</h1>
			</div>
			<div v-else-if="registering">
				<h1>Logger ind..</h1>
			</div>
			<div v-else>
				<transition mode="in-out">
					<div class="register-step register-step-1" v-if="step === 1">
						<div class="row">
							<div class="col-8">
								<label class="col-form-label">Klassetrin</label>
								<simple-select-box class="form-control" :options="classSteps" defaultLabel="Vælg klassetrin" v-model="selectedClassStep" castTo="int" />
							</div>
							<div class="col-4">
								<label class="col-form-label">Deltagere</label>
								<simple-select-box class="form-control" :options="participants" defaultLabel="-" v-model="selectedParticipants" />
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<label class="col-form-label">Landsdel</label>
								<simple-select-box class="form-control" :options="areas" defaultLabel="Vælg landsdel" v-model="selectedArea" />
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<label class="col-form-label">Skolenavn</label>
								<input type="text" class="form-control" placeholder="Navnet på din skole" v-model="selectedSchoolName" />
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<label class="col-form-label">Klassenavn</label>
								<input type="text" class="form-control" placeholder="F.eks. 9A, 9x, Blå" v-model="selectedClassName" />
							</div>
						</div>
						<div class="row mt-3">
							<div class="col-12">
								<p class="mb-0">Der kan kun registreres en klasse pr login</p>
							</div>
						</div>

						<div class="button-container row mt-3">
							<div class="col-12">
								<ist-button widthType="block" type="red" :disabled="!canRegister" v-on:click="register">Log ind</ist-button>
							</div>
						</div>
					</div>
				</transition>
			</div>
		</div>
	</div>
</template>

<script>
	import * as MutationTypes from '@/store/mutation-types'
	import {mapGetters} from 'vuex';
	import SimpleSelectBox from '@/components/common/SimpleSelectBox';
	import IstButton from '@/components/buttons/IstButton.vue';

	export default {
		name: 'client-register-view',
		components: {
			IstButton,
			SimpleSelectBox
		},
		data() {
			return {
				registering: false,

				classSteps: [],
				participants: [],
				areas: [],

				assocSchools: {},

				selectedClassStep: '',
				selectedParticipants: '',
				selectedSchoolName: '',
				selectedClassName: '',
				selectedArea: '',

				loading: true,

				step: 1,
			}
		},
		mounted() {
			this.loading = true;

			this.$apiClient.loadData().then((data) => {
				let areas = {};
				let classSteps = {};
				let participants = [];
				let areaIdIdentifiers = {};

				for (let i = 1; i <= 35; i++) {
					participants.push(i);
				}

				for (let area of data.areas) {
					areas[area.identifier] = area.name;
					areaIdIdentifiers[area.id] = area.identifier;
				}

				for (let area of data.classSteps) {
					classSteps[area.identifier] = area.name;
				}

				this.participants = participants;
				this.areas = areas;
				this.classSteps = classSteps;

				this.$store.commit(MutationTypes.SET_POLLS, data.polls);

				this.checkUidCookie().then((uid) => {
					// It already has a valid uid
					this.$store.commit(MutationTypes.SET_UID, uid);

					this.$router.push('/vote');
				}).catch((error) => {
					console.log(`checkUidCookie: ${error}`);

					this.loading = false;
				});
			});
		},
		methods: {
			checkUidCookie() {
				return new Promise((resolve, reject) => {
					let uid = this.$cookies.get('uid');

					if (uid) {
						// Verify uid
						this.$apiClient.noErrorHandler().verifyUid(uid).then(() => {
							resolve(uid); // Indeed, we have a valid uid
						}).catch(() => {
							reject('Uid cookie invalid');
						});
					} else {
						reject('Uid cookie not found');
					}
				});
			},
			register() {
				if (!this.canRegister) {
					return;
				}

				this.registering = true;

				// Create uid
				this.$apiClient.register({
					classStep: this.selectedClassStep,
					participants: this.selectedParticipants,
					schoolName: this.selectedSchoolName,
					className: this.selectedClassName,
					area: this.selectedArea,
				}).then((uid) => {
					this.$cookies.set('uid', uid);

					this.$store.commit(MutationTypes.SET_UID, uid);

					this.$router.push('/vote');
				}).finally(() => {
					this.registering = false;
				});
			}
		},
		computed: {
			canRegister() {
				if (!this.selectedClassStep) {
					return false;
				}

				if (!this.selectedParticipants) {
					return false;
				}

				if (!this.selectedArea) {
					return false;
				}

				if (!this.selectedSchoolName) {
					return false;
				}

				if (!this.selectedClassName) {
					return false;
				}

				return true;
			}
		}
	}
</script>

<style lang="scss" scoped>
	label {
		font-weight: bold;
	}
	.intro-container {
	}

	.logo-container {
		text-align: center;

		margin: 0 auto;

		img {
			max-width: 200px;
		}
	}

	h1 {
		text-align: center;
		line-height: 100%;

		margin-bottom: 0;
	}

	p {
		text-align: center;
		font-size: 10pt;
	}

	.button-container {
		text-align: center;
	}

	select {
		font-weight: bold;
	}
</style>
